import { useGetCheckoutCouponsByCouponCode } from "@birdwatch/client";

export const useCoupon = (couponCode: string) =>
  useGetCheckoutCouponsByCouponCode({ couponCode }).get({
    enabled: !!couponCode,
  });
